import axios from 'axios';

const instance = axios.create({
  baseURL: (process.env.VUE_APP_RUBY_URL || 'https://devopstest.petehealth.com:8080'),
  headers: {
    'Content-Type': 'application/json',
  }
});

instance.interceptors.request.use((config) => {
  const token = window.localStorage.getItem('authtoken');
  if (token) {
    config.headers.common.Authorization = `Basic ${token}`;
  }
  return config;
}, (error) => Promise.reject(error));

instance.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error.response.data)
);

export default instance;
